// ABOUTME: The sizes and colours both spinners accept, kept apart from the components themselves
// ABOUTME: A component file that also exports constants breaks fast refresh, hence the separate module

export type SpinnerSize = "xs" | "sm" | "md" | "lg" | "xl"
export type SpinnerColor = "info" | "gray" | "failure" | "success" | "warning" | "pink" | "purple"

export const sizeClasses: Record<SpinnerSize, string> = {
  xs: "h-3 w-3",
  sm: "h-4 w-4",
  md: "h-6 w-6",
  lg: "h-8 w-8",
  xl: "h-10 w-10",
}

export const colorClasses: Record<SpinnerColor, string> = {
  info: "text-blue-600",
  gray: "text-gray-600",
  failure: "text-red-600",
  success: "text-green-600",
  warning: "text-yellow-500",
  pink: "text-pink-600",
  purple: "text-purple-600",
}
